var d = new Date()

export function getYear() {
    return d.getFullYear() + ''
}

export function getMonth() {
    var m = d.getMonth() + 1 + ''
    return m < 10 ? '0' + m : m
}

export function getDay() {
    var day = d.getDate()
    return day < 10 ? '0' + day : day
}

export function getHour() {
    var hour = d.getHours()
    return hour < 10 ? '0' + hour : hour
}

export function getMinute() {
    var minute = d.getMinutes()
    return minute < 10 ? '0' + minute : minute
}
export function getSecond() {
    var second = d.getSeconds()
    return second < 10 ? '0' + second : second
}
export function getTime() {
    return getHour() + ':' + getMinute() + ':' + getSecond()
}

export function getDate(str) {
    if (str == '-' || str == '/') {
        return getYear() + str + getMonth() + str + getDay()
    } else {
        return getYear() + '年' + getMonth() + '月' + getDay() + '日'
    }
}

// ISO to LOACAL
// 2025-08-22T12:22:43.264788  to 2025/8/22 12:22:43
export function formatISOtoLoacal(isoString) {
    // 原生 Date 解析
    const date = new Date(isoString);
    return date.toLocaleString(); // 转换为本地时间格式（如 "2025/8/22 12:22:43"）
}

export function bytesToMB(bytes) {
    // 处理边界情况（避免除以0）
    if (bytes <= 0) return '0 MB';
    // 转换为MB并保留2位小数
    const mb = bytes / (1024 * 1024);
    return mb.toFixed(2) + ' MB';
}

export function isElectronEnv() {
    // Electron 会在渲染进程中注入 window.electron 或 window.require
    // 同时也可以检测 process 对象（Electron 渲染进程中存在）
    if (typeof window === 'undefined') return false;

    // 检测 Electron 特有的全局 API
    const hasElectronApi = !!window.electron ||
        (typeof window.require === 'function' &&
            typeof window.process === 'object' &&
            window.process.type === 'renderer');

    return hasElectronApi;
}

export function getScale() {
    const wh = window.innerHeight / 1080
    const ww = window.innerWidth / 1920
    // console.log(ww < wh ? ww : wh)
    return ww < wh ? ww : wh
}

// 获取图片 src 值的函数
// param: str 如 <p><img src="/api/images/logo.png" alt="" class="click-enlarge"></p>
export function getImageSrcFromHtml(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const img = doc.querySelector('img.click-enlarge');
    return img ? img.getAttribute('src') : null;
}
